import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.proto.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import { Weblog } from '@ks/weblogger';
import { ENV } from '@/index.config';
import { apiHook } from '@kdev-fe-common/common/apihook';
import Radar from '@ks-radar/radar';
import { nsKdevPing } from '@/remote';
export var weblogger = null;
var _userEmailPrefix = '';
export var radar = null;
var ignoreList = ['/api/kdev/ping'];
export var initLogger = function initLogger() {
  var userEmailPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  _userEmailPrefix = userEmailPrefix;
  // 本地调试时去掉这个判断
  if (weblogger || !ENV.IS_ONLINE() && !ENV.IS_TEST()) {
    return;
  }
  weblogger = new Weblog({
    // @ts-ignore 原因：autoPV 计算逻辑修改了，params 修改默认不计入 PV； 静态路由直接使用 url
    urlMap: function urlMap(_ref) {
      var page = _ref.page,
        url = _ref.url,
        params = _ref.params;
      return {
        page: url,
        params: params
      };
    },
    // env: 'production', // 本地调试时使用
    env: ENV.IS_ONLINE() ? 'production' : 'test',
    // logger: true, // 本地调试时使用
    logger: false,
    fps: false,
    timing: false
  }, {
    product_name: 'ks_serveree_testmgr',
    user_id: userEmailPrefix
  });
  // "@ks-radar/radar": "1.0.5-alpha.1", 变更还没有合入到weblogger里，所以要写成这样
  radar = new Radar({
    weblog: weblogger,
    projectId: '57a2765a55',
    // 雷达平台上的唯一标识
    sampling: 1,
    // 上报采样率，1 为全部上报
    ignoreList: ignoreList,
    // [cb] INP采集指标
    lcp: true,
    cls: true,
    fid: true,
    fcp: true,
    // [ce]
    APIHook: function APIHook(apiData) {
      return apiHook(apiData);
    },
    isIgnoreInvalidStatusCode: function () {
      var _isIgnoreInvalidStatusCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
        var resp, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return nsKdevPing.remote({});
            case 1:
              resp = _context.v;
              if (!(resp.status !== 200)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, true);
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              return _context.a(2, true);
            case 4:
              return _context.a(2, false);
          }
        }, _callee, null, [[0, 3]]);
      }));
      function isIgnoreInvalidStatusCode(_x) {
        return _isIgnoreInvalidStatusCode.apply(this, arguments);
      }
      return isIgnoreInvalidStatusCode;
    }()
  });
};

// 获取邮箱前缀
export var getUserEmailPrefix = function getUserEmailPrefix() {
  return _userEmailPrefix;
};

// 上报事件消息
export var sendImmediately = function sendImmediately(type, name, params) {
  weblogger && weblogger.sendImmediately(type, name,
  // 事件名称
  params);
};
export var sendImmediatelyPV = function sendImmediatelyPV() {
  weblogger && weblogger.sendImmediately('PV', {
    type: 'enter',
    status: 'SUCCESS',
    page: 'TEST_PLAY'
  });
};
export var sendImmediatelyVisit = function sendImmediatelyVisit() {
  weblogger && weblogger.sendImmediately('CLICK', {
    action: 'MOCK_CLICK',
    type: 'USER_OPERATION',
    urlPage: {
      page: 'TEST_PLAY' // location.href
    }
  });
};
export var sendImmediatelySwitch = function sendImmediatelySwitch(param) {
  weblogger && weblogger.sendImmediately('CLICK', {
    action: 'MOCK_START_OR_STOP',
    type: 'USER_OPERATION',
    params: param,
    urlPage: {
      page: 'TEST_PLAY'
    }
  });
};
export var sendImmediatelyClickCustom = function sendImmediatelyClickCustom(key, value) {
  weblogger && weblogger.sendImmediately('CUSTOM', {
    key: key,
    value: value,
    urlPage: {
      page: location.href
    }
  });
};